import { useMemo } from "react"
import {
  Button,
  Heading,
} from "@chakra-ui/react"
import { Link as ReactRouterLink } from "react-router-dom"
import { ColumnDef } from "@tanstack/react-table"
import { AddIcon } from "@chakra-ui/icons"
import { PaginatedTable } from "../components/PaginatedTable"
import { User } from "../models/User"
import { NavLayout } from "../components/NavLayout"

export const Users = () => {
  const columns = useMemo<ColumnDef<User>[]>(
    () => [
      {
        accessorKey: 'id',
        id: 'id'
      },
      {
        accessorKey: 'username',
        header: () => 'Username',
        footer: props => props.column.id,
      },
      {
        accessorKey: 'first_name',
        header: () => 'First Name',
        footer: props => props.column.id,
      },
      {
        accessorKey: 'last_name',
        header: () => 'Last Name',
        footer: props => props.column.id,
      },
      {
        accessorKey: 'phone',
        header: () => 'Phone',
        footer: props => props.column.id,
      },
      {
        accessorKey: 'email_address',
        header: () => 'Email',
        footer: props => props.column.id,
      },
      {
        accessorKey: 'organization',
        header: () => 'Organization',
        footer: props => props.column.id,
      },
    ],
    []
  )

  return (
    <NavLayout
      left={
        <Heading as="h1" size="lg">Users</Heading>
      }
      right={
        <Button
          as={ReactRouterLink}
          to="/users/add"
          boxShadow="dark-lg"
          variant="solid"
          colorScheme="green"
          aria-label="Add User"
          fontSize="20px"
          leftIcon={<AddIcon />}
        >
          Add User
        </Button>
      }
    >
      <PaginatedTable<User> dataKey="users" singular="User" endpoint="/users/index" columns={columns} />
    </NavLayout>
  )
}
